<div
  class="wrapper"
  [ngClass]="{
    regular: type === searchInputType.Regular,
    picker: type === searchInputType.Expandable,
    expanded: isExpanded
  }"
  >
  @if (type === searchInputType.Regular) {
    @if (placeholder) {
      <input
        [id]="id + '-search-input'"
        type="text"
        autocapitalize="none"
        [placeholder]="placeholder"
        [(ngModel)]="currentTextSearch"
        (keyup.enter)="onSearch()"
        [autocomplete]="autocomplete"
        pattern="([^\s][A-z0-9À-ž\s]+)"
        (ngModelChange)="textChanged($event)"
        [ngClass]="{ empty: !currentTextSearch }"
        />
    }
    @if (!placeholder) {
      <input
        [id]="id + '-search-input'"
        type="text"
        i18n-placeholder="@@InputSearchPlaceholder"
        [placeholder]="'CommonWebUI_InputSearch_Placeholder' | translate"
        [(ngModel)]="currentTextSearch"
        (keyup.enter)="onSearch()"
        [autocomplete]="autocomplete"
        pattern="([^\s][A-z0-9À-ž\s]+)"
        (ngModelChange)="textChanged($event)"
        [ngClass]="{ empty: !currentTextSearch }"
        />
    }
    @if (currentTextSearch) {
      <div
        [id]="id + '-search-clear'"
        class="icon clear"
        (click)="onClearText()"
      ></div>
    }
    <div
      [id]="id + '-search-start'"
      class="icon search"
      (click)="onSearch()"
    ></div>
  }
  @if (type === searchInputType.Expandable) {
    @if (placeholder) {
      <input
        #InputNoPlaceholder
        [id]="id + '-search-input'"
        type="text"
        autocapitalize="none"
        [placeholder]="placeholder"
        [(ngModel)]="currentTextSearch"
        (keyup.enter)="onSearch()"
        [autocomplete]="autocomplete"
        pattern="([^\s][A-z0-9À-ž\s]+)"
        (ngModelChange)="textChanged($event)"
        [ngClass]="{ empty: !currentTextSearch, expanded: isExpanded }"
        />
    }
    @if (!placeholder) {
      <input
        #InputNoPlaceholder
        [id]="id + '-search-input'"
        type="text"
        i18n-placeholder="@@InputSearchPlaceholder"
        [placeholder]="'CommonWebUI_InputSearch_Placeholder' | translate"
        [(ngModel)]="currentTextSearch"
        (keyup.enter)="onSearch()"
        [autocomplete]="autocomplete"
        pattern="([^\s][A-z0-9À-ž\s]+)"
        (ngModelChange)="textChanged($event)"
        [ngClass]="{ empty: !currentTextSearch, expanded: isExpanded }"
        />
    }
    @if (currentTextSearch) {
      <div
        [id]="id + '-search-clear'"
        class="icon clear"
        (click)="onClearText()"
      ></div>
    }
    <div
      [id]="id + '-search-start'"
      class="icon search"
      (click)="onSearchToggle()"
      (mouseover)="onMouseoverSearch()"
    ></div>
  }
</div>
